import React from "react";
import { Fragment, useState } from "react";
import { useSelector } from "react-redux";
import { Pinned } from "../../Utils/Constants";
import { H6, LI, UL } from "../../AbstractElements";
import SidebarSubMenu from "./SidebarSubMenu";
import BackButton from "./BackButton";
import { RootState } from "../../redux-toolkit/store";
import { useTranslation } from "react-i18next";
import { SidebarMenuType } from "../../Types/LayoutTypes";
import { useLiveQuery } from "dexie-react-hooks";
import { accessDB } from "../../db/accessDB";
import { log } from "console";

export default function SidebarNav() {
  const [activeMenu, setActiveMenu] = useState([]);
  const { pinedMenu } = useSelector((state: RootState) => state.layout);
  const accessData = useLiveQuery(() => accessDB.access.toArray());
  const canAccess = accessData?.[0]?.canAccess ?? false;
  console.log("Can Access:Route", canAccess);
  //    const canAccess = localStorage.getItem("canAccess");
  const unitId = useSelector((state: RootState) => state.orgUnit.id);
  const orgUnitId = localStorage.getItem("orgUnitId");
  console.log("Unit ID:", unitId);
  console.log("Org Unit ID:", orgUnitId);
  const { t } = useTranslation();
  const menuList: SidebarMenuType[] = [
    {
      title: "",
      menucontent: "Dashboards,Widgets",
      menu: [
        {
          id: 1,
          title: "Dashboards",
          icon: "home",
          type: "sub",
          menu: [
            {
              title: "Attendance",
              type: "link",
              url: `/admin`,
            },
            {
              title: "Performance",
              type: "link",
              url: `/activities`,
            },
            // {
            //     title: "FTP",
            //     type: "link",
            //     url: `/ftpImport`,
            // },
            // {
            //     title: "Employees",
            //     type: "link",
            //     url: `/employees`,
            // },
          ],
        },
        {
          id: 2,
          title: "Reports",
          icon: "widget",
          type: "sub",
          menu: [
            // {
            //   title: "Reports",
            //   type: "link",
            //   url: `/reports`,
            // },
            
            {
              title: "Effort",
              type: "link",
              url: `/effortReport`,
            },
            {
              title: "Daily Activity",
              type: "link",
              url: `/darReport`,
            },
            {
              title: "Input Distribution",
              type: "link",
              url: `/sgpiOutReport`,
            },
            {
              title: "RCPA Summary",
              type: "link",
              url: `/rcpaSkuSummary`,
            },
            {
              title: "Orders",
              type: "link",
              url: `/podReport`,
            },
            {
              title: "Joint Work",
              type: "link",
              url: `/jwReport`,
            },
            {
              title: "Expenses Spread",
              type: "link",
              url: `/expensesSummary`,
            },
            {
              title: "Expense Status",
              type: "link",
              url: `/expensesStatus`,
            },
            //    {
            //         title: "OVP",
            //         type: "link",
            //         url: `/ovpReport`,
            //     },
          ],
        },
        ...(String(unitId) === String(orgUnitId)
          ? [
              {
                id: 4,
                title: "Approvals",
                icon: "task",
                type: "link",
                active: false,
                url: `/Approvals`,
              },
            ]
          : []),
        // {
        //     id: 3,
        //     title: "FTP",
        //     icon: "file",
        //     type: "sub",
        //     menu: [
        //        {
        //             title: "FTP Import",
        //             type: "link",
        //             url: `/ftpImport`,
        //         },
        //        {
        //             title: "FTP Export",
        //             type: "link",
        //             url: `/ftpExport`,
        //         },
        //        {
        //             title: "FTP Import Logs",
        //             type: "link",
        //             url: `/ftpImportLogs`,
        //         },
        //        {
        //             title: "FTP Export Logs",
        //             type: "link",
        //             url: `/ftpExportLogs`,
        //         },

        //     ],
        // },
        ...(canAccess
          ? [
              {
                id: 2,
                title: "Debug",
                icon: "home",
                type: "sub",
                active: true,
                menu: [
                  {
                    title: "All Tables",
                    type: "link",
                    url: `/debug`,
                  },
                ],
              },
            ]
          : []),
      ],
    },
  ];
  const shouldHideMenu = (mainMenu: SidebarMenuType) => {
    return mainMenu.menu
      .map((data) => data.title)
      .every((tittles) => pinedMenu.includes(tittles as string));
  };
  return (
    <UL className="sidebar-links simple-list custom-scrollbar" id="simple-bar">
      <div className="simplebar-wrapper ">
        <div className="simplebar-mask ">
          <div className="simplebar-offset ">
            <div className="simplebar-content-wrapper">
              <div className="simplebar-content ">
                <BackButton />
                <LI
                  className={`pin-title sidebar-main-title ${
                    pinedMenu.length > 0 ? "show" : ""
                  } `}
                >
                  <div>
                    <H6>{Pinned}</H6>
                  </div>
                </LI>
                {menuList &&
                  menuList.map((mainMenu, i) => (
                    <Fragment key={i}>
                      <LI
                        className={`sidebar-main-title ${
                          shouldHideMenu(mainMenu) ? "d-none" : ""
                        }`}
                      >
                        <div>
                          <H6 className="lan-1">{t(`${mainMenu.title}`)}</H6>
                        </div>
                      </LI>
                      <SidebarSubMenu
                        menu={mainMenu.menu}
                        activeMenu={activeMenu}
                        setActiveMenu={setActiveMenu}
                        level={0}
                      />
                    </Fragment>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </UL>
  );
}
